import 'whatwg-fetch';

import React from 'react';
import PropTypes from 'prop-types';

import { iterUnpack, dedupe } from '../../services/APIClient';

import BrandDescription from '../BrandDescription';
import BrandFeaturedGallery from '../BrandFeaturedGallery';
import Alert from '../Alert';

export default class BrandDetailAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  UNSAFE_componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    const brand = props.allBrands[0];
    this.setState({
      isLoading: false,
      description: brand.description,
      featuredImages: dedupe(brand.featuredImages),
    });
  }

  defaultState = () => ({
    featuredImages: [],
    description: '',
  });

  render() {
    const { description, featuredImages } = this.state;
    const validDescription = description && description.length > 0;
    const validImages = featuredImages && featuredImages.length > 0;

    return (
      <div className="row">
        <h3 className="columns small-12 pb-base fs-m fw-medium">
          <i className="material-icons">info</i>
          {' '}
          About
        </h3>
        {validDescription || validImages
          ? (
            <div className="columns small-12">
              {validImages && <BrandFeaturedGallery images={featuredImages} />}
              <BrandDescription text={validDescription ? description : 'No Description'} />
            </div>
          )
          : (
            <Alert type="secondary" className="columns small-12">
              No Content Available
            </Alert>
          )}
        {!this.props.hideDivider
        && (
        <div className="columns small-12">
          <hr />
        </div>
        )}
      </div>
    );
  }
}

BrandDetailAbout.propTypes = {
  hideDivider: PropTypes.bool,
};

BrandDetailAbout.defaultProps = {
  hideDivider: false,
};
